import { tablet } from "../../../mediaQueries";

const styles = (theme) => ({
  root: {
    cursor: "none !important",
    padding: "12px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "rgba(197, 190, 181, 0.12)",
    margin: "5px 0",

    minWidth: "215px",
    color: "#575452",
    width: "100%",
    minHeight: "85px",
    transition: "all 0.2s",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
      minWidth: "180px",
    },
    "&:hover": {
      backgroundColor: "rgba(197, 190, 181, 0.2)",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      flexDirection: "column",
      minWidth: "130px",
      minHeight: "auto",
      margin: "0 .5rem",
    },
  },
  img: {
    cursor: "none !important",
    maxHeight: "60px",
    height: "100%",
    objectFit: "contain",
    boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      maxHeight: "auto",
    },
  },
  imgWrap: {
    cursor: "none !important",
    flexBasis: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      minHeight: "auto",
      width: "100%",
    },
  },
  primary: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    fontWeight: "500",
    color: "inherit",
    fontSize: "14px",
    lineHeight: "19.6px",
    letterSpacing: "0.02em",
    margin: 0,
    marginBottom: "4px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      fontSize: "1rem",
      marginTop: "12px",
      textAlign: "center",
      width: "100%",
    },
  },
  wrap: {
    cursor: "none !important",
    marginLeft: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      marginLeft: 0,
    },
  },
  secondary: {
    fontSize: "13px",
    letterSpacing: "0.02em",
    lineHeight: "18.2px",
    margin: 0,
    fontFamily: "Aktiv Grotesk",
    color: "inherit",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      fontSize: "14px",
      textAlign: "center",
      width: "100%",
    },
  },
  active: {
    cursor: "none !important",
    backgroundColor: "#989994 !important",
    color: "white !important",
  },
});

export default styles;
